(() => {
  'use strict';

  const SURCHARGE_VARIANT_ID = 58728115044726;
  const FONTS = [
    { value: 'Strak', label: 'Strak', css: 'Arial, Helvetica, sans-serif' },
    { value: 'Klassiek', label: 'Klassiek', css: 'Georgia, Times New Roman, serif' },
    { value: 'Speels', label: 'Speels', css: 'Trebuchet MS, Arial, sans-serif' },
    { value: 'Handgeschreven', label: 'Handgeschreven', css: 'cursive' }
  ];
  const THREAD_COLORS = [
    'Wit', 'Beige', 'Lichtgoud', 'Goud', 'Lavendel', 'Lichtroze',
    'Lichtblauw', 'Donkerblauw', 'Roest', 'Bruin', 'Olijfgroen',
    'Zwart', 'Rood'
  ];

  function currentHandle() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function isDrinkBottle(handle) {
    return handle.startsWith('trixie-drinkfles-') && handle.includes('-met-naam');
  }

  function isBackpack(handle) {
    return handle.startsWith('trixie-rugzak-') && handle.includes('-met-naam');
  }

  function injectStyles() {
    if (document.getElementById('studio-trixie-personalization-styles')) return;
    const style = document.createElement('style');
    style.id = 'studio-trixie-personalization-styles';
    style.textContent = `
      .studio-personalization{margin:22px 0;padding:20px;border:1px solid rgba(0,0,0,.12);border-radius:14px;background:#fff}
      .studio-personalization__title{margin:0 0 5px;font-size:1.75rem;font-weight:700;color:rgb(var(--color-foreground, 33,33,33))}
      .studio-personalization__intro{margin:0 0 16px;font-size:1.35rem;line-height:1.45;opacity:.78}
      .studio-personalization__field{display:block;margin:0 0 15px}
      .studio-personalization__label{display:flex;justify-content:space-between;gap:12px;margin:0 0 7px;font-size:1.35rem;font-weight:650}
      .studio-personalization__input,.studio-personalization__select{width:100%;min-height:46px;padding:10px 12px;border:1px solid rgba(0,0,0,.2);border-radius:10px;background:#fff;color:inherit;font:inherit}
      .studio-personalization__fonts{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:9px}
      .studio-personalization__font{position:relative}
      .studio-personalization__font input{position:absolute;opacity:0;pointer-events:none}
      .studio-personalization__font span{display:flex;align-items:center;justify-content:center;min-height:48px;padding:8px;border:1px solid rgba(0,0,0,.16);border-radius:10px;cursor:pointer;background:#fff;font-size:1.55rem;text-align:center}
      .studio-personalization__font input:checked + span{border-color:rgba(0,0,0,.72);box-shadow:inset 0 0 0 1px rgba(0,0,0,.72)}
      .studio-personalization__preview{margin-top:12px;padding:14px;border-radius:10px;background:rgba(0,0,0,.04);text-align:center;font-size:2rem;min-height:54px;display:flex;align-items:center;justify-content:center}
      .studio-personalization__choice{display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-bottom:15px}
      .studio-personalization__choice label{position:relative}
      .studio-personalization__choice input{position:absolute;opacity:0;pointer-events:none}
      .studio-personalization__choice span{display:flex;align-items:center;justify-content:center;min-height:46px;padding:9px 12px;border:1px solid rgba(0,0,0,.16);border-radius:10px;cursor:pointer;background:#fff;font-size:1.35rem;font-weight:600;text-align:center}
      .studio-personalization__choice input:checked + span{border-color:rgba(0,0,0,.72);box-shadow:inset 0 0 0 1px rgba(0,0,0,.72)}
      .studio-personalization__details[hidden]{display:none!important}
      .studio-personalization__note{margin:10px 0 0;font-size:1.2rem;line-height:1.45;opacity:.72}
      .studio-personalization__error{margin-top:10px;color:#b42318;font-size:1.25rem;font-weight:600}
      @media(max-width:749px){.studio-personalization{padding:16px}.studio-personalization__fonts{grid-template-columns:1fr 1fr}}
    `;
    document.head.appendChild(style);
  }

  function createFontChoices(groupName, required) {
    const wrap = document.createElement('div');
    wrap.className = 'studio-personalization__fonts';
    FONTS.forEach((font, index) => {
      const label = document.createElement('label');
      label.className = 'studio-personalization__font';
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = groupName;
      input.value = font.value;
      input.required = required;
      if (index === 0) input.checked = true;
      const sample = document.createElement('span');
      sample.textContent = font.label;
      sample.style.fontFamily = font.css;
      label.append(input, sample);
      wrap.appendChild(label);
    });
    return wrap;
  }

  function setupPreview(container, nameInput, fontName) {
    const preview = document.createElement('div');
    preview.className = 'studio-personalization__preview';
    preview.textContent = 'Jouw naam';
    container.appendChild(preview);

    const update = () => {
      const value = nameInput.value.trim() || 'Jouw naam';
      const selected = document.querySelector(`input[name="${fontName}"]:checked`);
      const font = FONTS.find((item) => item.value === selected?.value) || FONTS[0];
      preview.textContent = value;
      preview.style.fontFamily = font.css;
    };
    nameInput.addEventListener('input', update);
    container.addEventListener('change', update);
    update();
  }

  function insertBeforeQuantity(form, block) {
    const anchor = form.querySelector('.studio-pdp-quantity-label') || form.querySelector('.studio-pdp-purchase');
    if (anchor) form.insertBefore(block, anchor);
    else form.prepend(block);
  }

  function setupBottle(form) {
    if (form.querySelector('[data-trixie-personalization]')) return;
    injectStyles();

    const box = document.createElement('div');
    box.className = 'studio-personalization';
    box.dataset.trixiePersonalization = 'bottle';
    box.innerHTML = `
      <h2 class="studio-personalization__title">Personaliseer met naam</h2>
      <p class="studio-personalization__intro">Vul maximaal 8 tekens in en kies het lettertype.</p>
      <label class="studio-personalization__field">
        <span class="studio-personalization__label"><span>Naam</span><span data-count>0 / 8</span></span>
        <input class="studio-personalization__input" type="text" name="properties[Naam]" maxlength="8" autocomplete="off" required placeholder="Bijv. Sophie">
      </label>
      <div class="studio-personalization__field">
        <div class="studio-personalization__label"><span>Lettertype</span></div>
      </div>
      <p class="studio-personalization__note"><strong>Let op:</strong> controleer de spelling goed. Gepersonaliseerde artikelen worden speciaal voor jou gemaakt.</p>
    `;
    const field = box.querySelectorAll('.studio-personalization__field')[1];
    const fontName = 'properties[Lettertype]';
    field.appendChild(createFontChoices(fontName, true));
    const input = box.querySelector('input[name="properties[Naam]"]');
    const count = box.querySelector('[data-count]');
    input.addEventListener('input', () => { count.textContent = `${input.value.length} / 8`; });
    setupPreview(box, input, fontName);
    insertBeforeQuantity(form, box);
  }

  function setupBackpack(form) {
    if (form.querySelector('[data-trixie-personalization]')) return;
    injectStyles();

    const box = document.createElement('div');
    box.className = 'studio-personalization';
    box.dataset.trixiePersonalization = 'backpack';
    box.innerHTML = `
      <h2 class="studio-personalization__title">Personaliseren</h2>
      <p class="studio-personalization__intro">Laat de rugzak borduren met een naam voor €6,95 extra.</p>
      <div class="studio-personalization__choice" role="radiogroup" aria-label="Personaliseren">
        <label><input type="radio" name="properties[Personaliseren]" value="Nee" checked><span>Nee</span></label>
        <label><input type="radio" name="properties[Personaliseren]" value="Ja (+ €6,95)"><span>Ja + €6,95</span></label>
      </div>
      <div class="studio-personalization__details" hidden>
        <label class="studio-personalization__field">
          <span class="studio-personalization__label"><span>Naam</span><span data-count>0 / 7</span></span>
          <input class="studio-personalization__input" type="text" maxlength="7" autocomplete="off" placeholder="Bijv. Noor">
        </label>
        <div class="studio-personalization__field" data-font-field>
          <div class="studio-personalization__label"><span>Lettertype</span></div>
        </div>
        <label class="studio-personalization__field">
          <span class="studio-personalization__label"><span>Kleur garen</span></span>
          <select class="studio-personalization__select" data-thread-color>
            <option value="">Kies een kleur</option>
          </select>
        </label>
        <p class="studio-personalization__note"><strong>Totaal bij personalisatie:</strong> €51,90 per rugzak. Controleer naam, lettertype en garenkleur goed; gepersonaliseerde artikelen kunnen niet worden geretourneerd.</p>
      </div>
      <div class="studio-personalization__error" hidden></div>
    `;

    const details = box.querySelector('.studio-personalization__details');
    const nameInput = box.querySelector('.studio-personalization__input');
    const count = box.querySelector('[data-count]');
    const colorSelect = box.querySelector('[data-thread-color]');
    THREAD_COLORS.forEach((color) => {
      const option = document.createElement('option');
      option.value = color;
      option.textContent = color;
      colorSelect.appendChild(option);
    });

    const fontName = 'trixie-backpack-font';
    box.querySelector('[data-font-field]').appendChild(createFontChoices(fontName, false));
    setupPreview(details, nameInput, fontName);
    nameInput.addEventListener('input', () => { count.textContent = `${nameInput.value.length} / 7`; });

    const radios = box.querySelectorAll('input[name="properties[Personaliseren]"]');
    const sync = () => {
      const yes = box.querySelector('input[name="properties[Personaliseren]"]:checked')?.value.startsWith('Ja');
      details.hidden = !yes;
      nameInput.required = Boolean(yes);
      colorSelect.required = Boolean(yes);
      box.querySelectorAll(`input[name="${fontName}"]`).forEach((input) => { input.required = Boolean(yes); });
      if (!yes) box.querySelector('.studio-personalization__error').hidden = true;
    };
    radios.forEach((radio) => radio.addEventListener('change', sync));
    sync();
    insertBeforeQuantity(form, box);

    form.addEventListener('submit', async (event) => {
      const yes = box.querySelector('input[name="properties[Personaliseren]"]:checked')?.value.startsWith('Ja');
      if (!yes) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const errorBox = box.querySelector('.studio-personalization__error');
      errorBox.hidden = true;
      const name = nameInput.value.trim();
      const font = box.querySelector(`input[name="${fontName}"]:checked`)?.value || '';
      const color = colorSelect.value;
      if (!name || !font || !color) {
        errorBox.textContent = 'Vul de naam, het lettertype en de garenkleur in.';
        errorBox.hidden = false;
        if (!name) nameInput.focus();
        return;
      }

      const variantInput = form.querySelector('[data-variant-id], input[name="id"]');
      const quantityInput = form.querySelector('[data-qty-input], input[name="quantity"]');
      const baseVariantId = Number(variantInput?.value);
      const quantity = Math.max(1, Number(quantityInput?.value) || 1);
      const submit = form.querySelector('[data-add-to-cart], button[type="submit"]');
      if (!baseVariantId) return;

      const properties = {
        Personaliseren: 'Ja (+ €6,95)',
        Naam: name,
        Lettertype: font,
        'Kleur garen': color
      };

      try {
        if (submit) submit.disabled = true;
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: baseVariantId, quantity, properties },
              {
                id: SURCHARGE_VARIANT_ID,
                quantity,
                properties: {
                  Voor: document.querySelector('.studio-pdp-buybox__title')?.textContent.trim() || 'Trixie rugzak',
                  Naam: name,
                  Lettertype: font,
                  'Kleur garen': color
                }
              }
            ]
          })
        });
        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || payload.message || 'Toevoegen aan winkelwagen mislukt.');
        }
        window.location.href = window.routes?.cart_url || '/cart';
      } catch (error) {
        errorBox.textContent = error.message || 'Er ging iets mis. Probeer het opnieuw.';
        errorBox.hidden = false;
        if (submit) submit.disabled = false;
      }
    }, true);
  }

  function init(root = document) {
    const handle = currentHandle();
    if (!handle) return;
    const sections = root.querySelectorAll ? root.querySelectorAll('[data-studio-product-v2]') : [];
    sections.forEach((section) => {
      const form = section.querySelector('.studio-pdp-form');
      if (!form) return;
      if (isDrinkBottle(handle)) setupBottle(form);
      if (isBackpack(handle)) setupBackpack(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
